import ReactMounter from 'lib/ReactMounter';
import ClubDealsPage from 'pages/ClubDealsPage/ClubDealsPage';

ReactMounter.registerComponentToMountOnLoad('ClubDealsPage', ClubDealsPage);
